import moment from 'moment';
import 'moment-timezone';
import { getUseBrowserTimeZone } from './timezoneConfig';

const wrappedMoment = (...args) => {
  return getUseBrowserTimeZone()
    ? moment.utc(...args).local()
    : moment(...args);
};

Object.keys(moment).forEach(key => {
  wrappedMoment[key] = moment[key];
});
wrappedMoment.tz = moment.tz;

export default wrappedMoment;